import { render, staticRenderFns } from "./GeoscriptDetail.vue?vue&type=template&id=89772c12&scoped=true&"
import script from "./GeoscriptDetail.vue?vue&type=script&lang=js&"
export * from "./GeoscriptDetail.vue?vue&type=script&lang=js&"
import style0 from "./GeoscriptDetail.vue?vue&type=style&index=0&id=89772c12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89772c12",
  null
  
)

export default component.exports